import { toast } from 'react-toastify'

export const successToast = message => toast(`${message}`)

export const errorToast = message => toast(`${message}`)